import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './StepsIcons.module.css';

import type { StepData } from '@Pages/PageQuizMattrasses';
import type { HTMLAttributes, MouseEvent, FC } from 'react';

export type OnChangeStep = (e: MouseEvent, step: StepData) => void;

export interface StepsIconsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  steps: StepData[];
  selectedStep?: number;
  onChangeStep?: OnChangeStep;
}

const StepsIcons: FC<StepsIconsProps> = (props) => {
  const { className, steps, selectedStep = 0, onChangeStep, ...restProps } = props;

  const handleChangeStep: OnChangeStep = useCallback(
    (e, step) => {
      if (onChangeStep) onChangeStep(e, step);
    },
    [onChangeStep],
  );

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.container}>
        {steps.map((step, index) => {
          const visited = index <= selectedStep;
          const skipped = index < selectedStep && step.skipped;
          const active = index === selectedStep;

          return (
            <div
              key={index}
              className={cn(styles.step, {
                [styles.visited]: visited,
                [styles.skipped]: skipped,
                [styles.active]: active,
              })}
            >
              <div
                className={styles.wrapperIcon}
                key={step.id}
                onClick={(e) => handleChangeStep(e, step)}
              >
                <Img className={styles.icon} src={step.icon} cnImage={styles.img} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default memo(StepsIcons);
